import { Flex, Typography } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

import { LoadingCondition } from '@jane/business-admin/components/shared/specials/modal/conditions/generic_components/LoadingCondition';
import { FORM_FIELD_DEFAULT_MARGIN } from '@jane/business-admin/components/shared/specials/modal/form';

import { MenuRowCard } from './MenuRowModal';

export interface ThresholdsCardProps {
  isLoading: boolean;
}

/** @todo allow extending to includes+excludes */
const THRESHOLD_PATH = 'rules.includes[0].products_created_within_days';

export const ThresholdsCard = ({ isLoading }: ThresholdsCardProps) => {
  if (isLoading) return <LoadingCondition />;

  return (
    <MenuRowCard>
      <Flex flexDirection="column">
        <Typography variant="header-bold" branded>
          Thresholds
        </Typography>
        <Typography color="grays-mid" mb={FORM_FIELD_DEFAULT_MARGIN}>
          Define when items qualify for this row. Products that qualify will
          automatically populate the row.
        </Typography>
        <Flex flexDirection="column">
          <Form.NumberField
            required
            min={1}
            label="Show on menu for"
            shouldUnregister={false}
            name={THRESHOLD_PATH}
            width="50%"
          />
          <Typography color="grays-mid" mt={12}>
            Days until item ages out of the row
          </Typography>
        </Flex>
      </Flex>
    </MenuRowCard>
  );
};
